module.exports = __webpack_public_path__ + "static/media/logo-longfonds.1eb2c0ac.png";